import { useState, useContext } from "react";
import {
  Stack,
  Typography,
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
//Srcs
import "./dashboardstyle.scss";
import "../../Style/pagestyle.scss";
import EmptyData from "../Include/EmptyData/EmptyData";
// import LoadingPage from "../../Utils/LoadingPage";
import { AuthContext } from "../../Context/AuthContext";
import useGetScheduleForDashboard from "../../Hooks/useGetScheduleForDashboard";
import { SelectCourse } from "../Include/DynamicSelect/DynamicSelect";

export default function TeacherBySchedule() {
  const { t } = useContext(AuthContext);
  let navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [courseVal, setCourseVal] = useState({ id: "", title: "" });
  const [filterDay, setFilterDay] = useState("Monday");

  const limit = 1;

  const { totalCount, tableData, loading } = useGetScheduleForDashboard({
    page,
    limit,
    day: filterDay,
    courseId: courseVal?.id,
  });

  const totalPages = Math.ceil(totalCount / limit);

  // console.log("tableData::", tableData)

  return (
    <div className="chart-container">
      <Stack
        direction="column"
        justifyContent="space-between"
        sx={{ height: "100%" }}
      >
        <Stack direction="column" spacing={2}>
          <Stack direction="row" justifyContent={"space-between"}>
            <Typography className="chart-title">
              {t("student_statistic_by_class")}
            </Typography>

            <Stack direction="row" spacing={1} sx={{ width: "60%" }}>
              <FormControl
                className={"text-field"}
                fullWidth
                size="small"
                sx={{ width: "50%" }}
              >
                <Select
                  value={filterDay}
                  onChange={(e) => setFilterDay(e.target.value)}
                >
                  <MenuItem value={"Monday"}>Monday</MenuItem>
                  <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                  <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                  <MenuItem value={"Thursday"}>Thursday</MenuItem>
                  <MenuItem value={"Friday"}>Friday</MenuItem>
                  <MenuItem value={"Saturday"}>Saturday</MenuItem>
                  <MenuItem value={"Sunday"}>Sunday</MenuItem>
                </Select>
              </FormControl>

              <Box sx={{ width: "50%" }}>
                <SelectCourse
                  buttonAdd={false}
                  onChange={(val) => setCourseVal(val || { id: "", title: "" })}
                  value={courseVal}
                />
              </Box>
            </Stack>
          </Stack>

          {tableData?.length === 0 || tableData === undefined ? (
            <Stack
              direction="column"
              justifyContent="center"
              sx={{ height: "300px" }}
            >
              <EmptyData />
            </Stack>
          ) : (
            <Stack direction={"column"} spacing={1}>
              <Stack direction="row" sx={{ padding: "0px 10px" }}>
                <Typography className="student-name" sx={{ width: "5%" }}>
                  {t("no")}
                </Typography>
                <Typography className="student-name" sx={{ width: "28%" }}>
                  {t("thead_class")}
                </Typography>
                <Typography className="student-name" sx={{ width: "25%" }}>
                  {t("thead_teacher")}
                </Typography>
                <Typography className="student-name" sx={{ width: "20%" }}>
                  {t("thead_time")}
                </Typography>
                <Typography
                  className="student-name"
                  sx={{
                    width: "11%",
                    textAlign: "center",
                  }}
                >
                  {t("studying")}
                </Typography>
                <Typography
                  className="student-name"
                  sx={{ width: "11%", textAlign: "center" }}
                >
                  {t("complete")}
                </Typography>
              </Stack>
              <Stack direction="column" spacing={1}>
                {tableData?.map((row, index) => {
                  // console.log("row::", row);
                  return (
                    <Stack direction="row" key={index} className="student-card">
                      <Stack
                        sx={{ width: "5%" }}
                        direction={"column"}
                        justifyContent={"center"}
                      >
                        <Typography className="class-name-title">
                          {index + 1}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{ width: "28%" }}
                        direction={"column"}
                        justifyContent={"center"}
                      >
                        <Typography className="class-name-title">
                          {row?.classId?.courseId?.enName +
                            " " +
                            row?.classId?.className}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{ width: "25%" }}
                        direction={"column"}
                        justifyContent={"center"}
                      >
                        <Typography className="class-name-title">
                          {row?.teacherId?.familyName +
                            " " +
                            row?.teacherId?.userName}
                        </Typography>
                      </Stack>
                      <Stack
                        sx={{ width: "42%" }}
                        direction={"column"}
                        spacing={1}
                      >
                        {row?.times?.map((data, subIndex) => {
                          return (
                            <Stack
                              className="class-name-title"
                              direction={"row"}
                              key={subIndex}
                            >
                              <span
                                style={{
                                  width: "52%",
                                }}
                              >
                                {data?.startTime + "-" + data?.endTime}
                              </span>
                              <span
                                style={{
                                  width: "29%",
                                  textAlign: "center",
                                }}
                              >
                                {data?.totalStudying}
                              </span>
                              <span
                                style={{ width: "29%", textAlign: "center" }}
                              >
                                {data?.totalComplete}
                              </span>
                            </Stack>
                          );
                        })}
                      </Stack>
                    </Stack>
                  );
                })}
              </Stack>
            </Stack>
          )}
        </Stack>

        {/* ==================== Pagination  ============================= */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Stack direction={"row"} spacing={2}>
            <Button
              className="btn-next"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </Button>
            <Button
              className="btn-next"
              disabled={page === totalPages}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </Button>
          </Stack>

          <Button
            className="btn-see-more"
            onClick={() =>
              navigate(
                `/report?reportType=${"student-statistic"}&&courseId=${
                  courseVal?.id
                }`,
              )
            }
          >
            {t("view_report")}
          </Button>
        </Box>
      </Stack>
    </div>
  );
}
